import { h } from 'preact'

import { EscalationModalProps } from '../../interfaces'
import { ModalActionButtons, ModalTitle } from '../../ModalComponents'

/* eslint-disable import/no-internal-modules */
import Modal from '../../../../../../components/reactModal'
import Icon from '@insided/deprecated-preact-components/assets'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import Textarea from '@insided/deprecated-control/ui-components/Textarea'
import { DropdownSelectizeInput } from '@insided/deprecated-preact-components/dropdown/DropdownSelectize'

interface Props extends EscalationModalProps {
  tags?: string []
  onChangeTags: (values: string[]) => void
}

const CreateProductboardNoteModal = ({ isOpen, closeModal, onSubmit, title, username, onChangeCallback, content, onContentChange, onChangeTags, tags, titleValidationError, contentValidationError, onTextareaFocus, onClickCallback, isLoading }: Props) => {
  const hasContentValidationError = contentValidationError !== undefined
  return (
    <Modal isOpen={isOpen} onClose={() => closeModal()}>
      <div className='integration__create_note_modal integration__escalate_modal'>
        <ModalTitle title='Create a Productboard note' imageName='productboard' />
        <div className='modal-description'>
          <div className='modal-user-email-field modal-data'>
            <label>User</label>
            <div>{username}</div>
          </div>
          <div className='modal-post-title-field modal-data'>
            <InputGroup
              title='Title'
              key='post-title'
              required
              qaClasses='qa-post-title'
              value={title}
              error={titleValidationError}
              onChangeCallback={(e: ChangeEvent) => onChangeCallback(e.target.value)}
              onClick={onClickCallback}
              showIconBeforeErrorMessage
            />
          </div>
          <label>Description</label>
          <div className='modal-post-content-field modal-data'>
            <Textarea
              adjustHeight
              verticalResize
              disableGramm
                // eslint-disable-next-line @gorazdo/preact/prefer-classname
              class='modal-post-content'
              newStyle
              onContentChange={onContentChange}
              value={content?.replace(/<[^>]*>?/gm, ' ') ?? ''}
              error={hasContentValidationError}
              onTextareaFocus={onTextareaFocus}
            />
            {hasContentValidationError && <div className='error-message-container'>
              <div><Icon customClass='icon-warning' icon='warning' /></div>
              <div className='error-message-text'>Please fill in the required field</div>
            </div>}
          </div>
          <div className='modal-tags-field modal-data'>
            <label>Tags <span className='label-optional'>(optional)</span></label>
            <DropdownSelectizeInput
              items={[]}
              single={false}
                // eslint-disable-next-line @gorazdo/preact/prefer-classname
              class='form-control qa-productboard-tags modal-tags'
              placeholder=''
              selectedItems={tags?.length ? tags : (tags ?? [])}
              onChange={onChangeTags}
            />
          </div>
        </div>
        <ModalActionButtons onSubmit={onSubmit} isLoading={isLoading} closeModal={closeModal} />
      </div>
    </Modal>
  )
}

export default CreateProductboardNoteModal
